$('.js-vouchers-form').on('submit', e => e.preventDefault()).validate({
    submitHandler: function (form) {
        var $form = $(form);

        $form.find('input[name="voucher"]').blur();
        $form.find('button[type="submit"]').addClass('is-loading');

        Form.ajaxPost(form, function (data) {
            Eshop.alert(data.message, { type: data.status ? 'success' : 'error' });

            if (data.status) {
                location.reload();
            } else {
                $form.find('button[type="submit"]').removeClass('is-loading');
            }
        }, "json");
    }
});

$(function () {
    $('.js-import-form-input').on('change', function () {
        $('.js-import-form').submit();

        $(this).prop('disabled', true);
        $(this).siblings('.c-btn').addClass('is-loading');
    });

    $('.js-change-product-price').on('submit', function(e) {
        var $form = $(this)

        if ($form.find('[type="submit"]').prop('disabled')) {
            e.preventDefault()
            return false
        }

        $form.find('[type="submit"]').prop('disabled', true).addClass('is-loading')
    });
});